import type { DocumentAndCountryConfiguration, DocumentUploadSettings } from '@onefootprint/request-types/dashboard';
import type { CollectDocumentNodeProps } from '@/playbook-builder/playbook-builder.types';

const getDocumentIdentityConfig = (
  node: CollectDocumentNodeProps,
): {
  collectSelfie: boolean;
  documentTypesAndCountries: DocumentAndCountryConfiguration;
  uploadSettings: DocumentUploadSettings;
} => {
  const idDocs = node.data.documents.find(doc => doc.kind === 'identity');
  if (idDocs) {
    return {
      collectSelfie: idDocs.data.collectSelfie,
      documentTypesAndCountries: idDocs.data.documentTypesAndCountries ?? {
        global: [],
        countrySpecific: {},
      },
      uploadSettings: 'prefer_capture',
    };
  }

  return {
    collectSelfie: false,
    documentTypesAndCountries: {
      global: [],
      countrySpecific: {},
    },
    uploadSettings: 'prefer_capture',
  };
};

export default getDocumentIdentityConfig;
